/**
 * Created by sarimz on 6/21/17.
 */
import UAParser from 'ua-parser-js';
import { browserHistory} from 'react-router';
import { appLogger } from 'app-lib/helpers/logging';
const logger = appLogger.create('browser-detect-helper');

export function checkNameAndVersion() {
    try {
        const uaParser = new UAParser;
        const name = uaParser.getBrowser() ? uaParser.getBrowser().name : '';
        const bversion = uaParser.getBrowser() ? uaParser.getBrowser().version : '';
        let version;

        // if the version is in the form of semver (10.5.6), extract the major number
        if (bversion.indexOf('.') !== 0) {
            version = bversion.split('.')[0];
        } else {
            version = bversion;
        }

        if ((name === 'safari' && version < 9) || (name === 'chrome' && version < 44) ||
            (name === 'ie' && version < 11) || (name === 'edge' && version < 14) ||
            (name === 'firefox' && version < 52)) {
            logger.error('Unsupported Browser', { name, version });
            browserHistory.push('/unsupportedBrowser');
        }

        // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
        // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
        // to avoid the entire page breaking, without having to do a check at each usage of Storage.
        if (typeof localStorage === 'object') {
            try {
                localStorage.setItem('localStorage', 1);
                localStorage.removeItem('localStorage');
            } catch (e) {
                Storage.prototype._setItem = Storage.prototype.setItem;
                Storage.prototype.setItem = function () {};
                browserHistory.push('/unsupportedBrowser');
            }
        }
    } catch (e) {
        console.log(e);
    }
}

export function isMobile() {
    const uaParser = new UAParser;
    return (uaParser.getOS().name === 'Android' || uaParser.getOS().name === 'iOS');
}




// WEBPACK FOOTER //
// ./src/app-lib/helpers/browser-detect-helper.js